import { render, staticRenderFns } from "./SurveyStatistics.vue?vue&type=template&id=709fbaae"
import script from "./SurveyStatistics.vue?vue&type=script&lang=js"
export * from "./SurveyStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports